import * as React from "react";

import { useTab_unstable } from "@fluentui/react-components";

import { useMergedTooltipAndKeytipRef } from "@1js/acui-hooks";
import type { OnExecuteParameter } from "@1js/acui-common";

import { deriveTabKeytip } from "@1js/acui-keytip";
import type { AppTabProps, AppTabState } from "./AppTab.types";

export const useAppTab = (
  props: AppTabProps,
  ref: React.Ref<HTMLButtonElement>
): AppTabState => {
  const { ariaLabel } = props;

  const { onTabHeaderExecute, title } = props;

  const onExecute = React.useCallback(
    (param: OnExecuteParameter) => {
      if (onTabHeaderExecute) {
        onTabHeaderExecute(
          param.id,
          { event: param.event, inputMethod: param.inputMethod },
          param.triggerTime
        );
      }
    },
    [onTabHeaderExecute]
  );

  const mergedRefWithKeytip = useMergedTooltipAndKeytipRef(
    {
      ...props,
      deriveKeytip: deriveTabKeytip,
      hideLabel: false,
      label: title,
      onExecute,
      shouldTakeFocus: false,
    },
    ref,
    "AppButton"
  );

  const tabChildren = props.children || <>{title}</>;

  const tabState = useTab_unstable(
    {
      ...props,
      "aria-label": ariaLabel,
      children: tabChildren,
      title: undefined,
    },
    mergedRefWithKeytip
  );

  return {
    ...props,
    ...tabState,
  } as AppTabState;
};
